



























































import { Component, Prop, Vue } from "vue-property-decorator";
import { GapLogType } from "@/store/modules/enums";
import { GapLogEntry } from "@/store/modules/types";
import Swal from 'sweetalert2';

@Component
export default class NotifGapSMS extends Vue {
  @Prop(String) readonly publicId!: string;
  smsConfig: any = null;
  comment = "";
  async getSMSConfig() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "notifs/getGapSMS",
        this.publicId
      );
      data.WEB_OPTIONS = data.WEB_OPTIONS.map(option => {
        option.selected = false;
        return option;
      });
      this.smsConfig = data;
      this.sendAck();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async sendAck() {
    try {
      const entry: GapLogEntry = {
        gapId: this.smsConfig.GAP_ID,
        typeId: GapLogType.PATIENT_ACKNOWLEDGED_SMS_NOTIFICATION
      };
      await this.$store.dispatch("gaps/saveSystemLog", entry);
    } catch (error) {
      console.log(error);
    }
  }
  async sendComment() {
    if (!this.comment) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      /*
      const entry: GapLogEntry = {
        gapId: this.smsConfig.GAP_ID,
        typeId: GapLogType.PATIENT_COMMENT,
        comment: this.comment
      };
      await this.$store.dispatch("gaps/saveSystemLog", entry);
      */
      await this.$store.dispatch("notifs/saveGapSMSComment", {
        publicId: this.publicId,
        text: this.comment
      });
      this.comment = "";
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Thank you! We have received your <b>comment</b>."
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async respond(option) {
    if (option.selected) {
      return;
    }

    for (const opt of this.smsConfig.WEB_OPTIONS) {
      opt.selected = false;
    }

    let comment = null;

    try {

      if (option.ALLOW_COMMENT === true) {

        const result = await Swal.fire({
          title: "Add a comment (optional)",
          input: "textarea",
          inputPlaceholder: "Write your comment here...",
          icon: "question",
          confirmButtonText: '<i class="fa fa-paper-plane"></i> Continue',
          showCancelButton: false,
          buttonsStyling: false, 
          allowOutsideClick: false, 
          allowEscapeKey: false,
          customClass: {
            confirmButton: 'custom-continue-btn'
          }
        });

         comment = result.value || null;
      }

      this.$store.commit("main/SET_LOADING", true);

      await this.$store.dispatch("notifs/saveGapSMSResponse", {
        publicId: this.publicId,
        text: option.VALUE,
        comment: comment 
      });

      option.selected = true;
      this.$store.commit("main/SET_LOADING", false);
      await Swal.fire({
        title: "PatientCare",
        html: "Thank you! We have received your <b>answer</b>.",
        icon: "success"
      });

    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async respondBK(option) {
    if (option.selected) {
      return;
    }
    for (const option of this.smsConfig.WEB_OPTIONS) {
      option.selected = false;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("notifs/saveGapSMSResponse", {
        publicId: this.publicId,
        text: option.VALUE
      });
      option.selected = true;
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Thank you! We have received your <b>answer</b>."
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  mounted() {
    this.getSMSConfig();
  }
}
